module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABRklEQVQ4T+3Ur0uDQRgH8O+zd7ImBsEwWBoWg8WmYVEQDcIb9H1Nvhu8V9Qs6lTMiuE9dGfyXBHLsNgGYrOIGMQm7B+wDbd75J1sDFE5xxCDV+/7fO4XzxH6PKjPHrpB8vPhLJjGASRsFjLETbC5L6ujCgCOa9ogeXlxAeY0ga4ANG1AAA4Tpglc0yU5H6Mt0M+Hc4zEeu3pYbJarTYssVYsl8sl09mxGyKzp0uy8g4GYgPAgFbR5k+wdtYPxA6AV62i3Ta4FU9qFW33CHbq/8G/eodeEK4SMKqVFL28sheEEsDjmZIHrVd2lwqZVCp5C8NBNjNyWSwWjQ3suq6TGhqeAZOq1xsT56fHz51eXiiIKcfwIci+lwEYMN8BWNFKXnf3ss2GrDKffl+Ly2ItQRj8TjCMl/JJtP8x8zug1dm+CPX9x34DDA2TFY0/huYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/client.png
// module id = 761
// module chunks = 114